// @flow

import { KbmOsagoPolicyModel, KbmPolicy } from './model.js';

export default class KbmOsagoPolicyMapper {
	_kbmOsagoPolicyModel: KbmOsagoPolicyModel;

	constructor (kbmOsagoPolicyModel: KbmOsagoPolicyModel) {
		this._kbmOsagoPolicyModel = kbmOsagoPolicyModel;
	}

	mapToKbmPolicy = (kbmPolicy: KbmPolicy) => {
		kbmPolicy.Series.fromJS(this._kbmOsagoPolicyModel.PolicySeries());
		kbmPolicy.Number.fromJS(this._kbmOsagoPolicyModel.PolicyNumber());
		kbmPolicy.UnlimitedDrivers.fromJS(this._kbmOsagoPolicyModel.IsUnlimitedDrivers());

		kbmPolicy.OwnerIndividual.FirstName.fromJS(this._kbmOsagoPolicyModel.Owner.FirstName());
		kbmPolicy.OwnerIndividual.LastName.fromJS(this._kbmOsagoPolicyModel.Owner.LastName());
		kbmPolicy.OwnerIndividual.MiddleName.fromJS(this._kbmOsagoPolicyModel.Owner.MiddleName());
		kbmPolicy.OwnerIndividual.Birthday.fromJS(this._kbmOsagoPolicyModel.Owner.Birthday());
	}
}